import React from "react";
import ContraVoucher from './Contra_Voucher';

const ContraApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Contra Voucher</h5>
          </div>
        </div>
        <ContraVoucher />
      </div>
    </div >
  );
};

export default ContraApp;
